<template>
  <div class="scenarios-page">
    <autoplay-video>
      <source v-for="video in videos" :key="video.url" :src="video.url" :type="video.type" />
    </autoplay-video>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AutoplayVideo from "../components/AutoplayVideo";

export default {
  components: { AutoplayVideo },
  computed: mapState({
    videos: (state) => state.scenario.video,
  }),
};
</script>

<style lang="less">
.video-page {
  .page-title {
    position: absolute;
    bottom: 30px;
    left: 90px;
    font-size: 13px;
    color: #f1ece6;

    a {
      cursor: pointer;
    }
  }
}
</style>
